import { render, staticRenderFns } from "./GetAbstract.vue?vue&type=template&id=b2057064&scoped=true&"
import script from "./GetAbstract.vue?vue&type=script&lang=js&"
export * from "./GetAbstract.vue?vue&type=script&lang=js&"
import style0 from "./GetAbstract.vue?vue&type=style&index=0&id=b2057064&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2057064",
  null
  
)

export default component.exports